import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { House, ListBullets, ChatCircleDots, Folders, Truck, SignOut, UserCircle, DotsThree } from "@phosphor-icons/react";
import { useUnreadCount } from "./useUnreadCount";
import DemoExperience from "../../components/demo/DemoExperience";

function NavItem({ to, label, icon: Icon, testid, badge, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `flex-1 flex flex-col items-center justify-center gap-1 py-2 text-[10px] font-bold uppercase tracking-wider relative ${
          isActive ? "text-white" : "text-neutral-500"
        }`
      }
      data-testid={testid}
    >
      {({ isActive }) => (
        <>
          <div className={`p-1.5 rounded ${isActive ? "bg-red-600" : ""}`}>
            <Icon size={20} weight={isActive ? "fill" : "bold"} />
          </div>
          {label}
          {badge ? (
            <span className="absolute top-0 right-1/4 bg-red-600 text-white text-[9px] font-bold rounded-full px-1.5 py-0.5 min-w-[16px] text-center">
              {badge > 9 ? "9+" : badge}
            </span>
          ) : null}
        </>
      )}
    </NavLink>
  );
}

export default function DriverShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const unread = useUnreadCount();
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#0A0A0A", color: "#fff" }}>
      <header className="px-4 py-3 flex items-center justify-between border-b border-neutral-800">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center"><img src="/logo.png?v=rf2026-newlogo-0804" alt="Roll Fast logo" className="w-8 h-8 object-contain" /></div>
          <div>
            <div className="label-tag text-neutral-500">Roll Fast · Portal</div>
            <div className="font-display font-bold leading-tight">{user?.name}</div>
          </div>
          {user?.is_demo && (
            <span data-testid="demo-mode-badge"
                    className="inline-flex items-center gap-1.5 ml-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider"
                    style={{ background: "rgba(229,9,20,0.18)", color: "#F87171", border: "1px solid rgba(229,9,20,0.4)" }}>
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-current opacity-90" />
              Demo
            </span>
          )}
        </div>
        <div className="flex items-center gap-1">
          <button onClick={() => nav("/driver/profile")} data-testid="driver-profile-button" className="text-neutral-400 p-2" title="My Profile">
            <UserCircle size={22} weight="bold" />
          </button>
          <button onClick={async () => { await logout(); nav("/login"); }} data-testid="driver-logout-button" className="text-neutral-400 p-2">
            <SignOut size={20} weight="bold" />
          </button>
        </div>
      </header>
      <main id="main-content" tabIndex={-1} role="main" aria-label="Roll Fast driver content" className="flex-1 pb-24 overflow-x-hidden text-white" style={{ background: "#050505" }}><Outlet /></main>
      <nav className="fixed bottom-0 left-0 right-0 border-t border-neutral-800 flex" style={{ background: "#0A0A0A" }}>
        <NavItem to="/driver" label="Home" icon={House} testid="driver-nav-home" end />
        <NavItem to="/driver/loads" label="Loads" icon={ListBullets} testid="driver-nav-loads" />
        <NavItem to="/driver/chat" label="Chat" icon={ChatCircleDots} testid="driver-nav-chat" badge={unread.chat} />
        <NavItem to="/driver/docs" label="Docs" icon={Folders} testid="driver-nav-docs" />
        <NavItem to="/driver/more" label="More" icon={DotsThree} testid="driver-nav-more" />
      </nav>
      <DemoExperience />
    </div>
  );
}
